/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */

/**
 * 报警消息
 */
import React from 'react';
import WarningMassageContentModal from './WarningMassageContentModal';
import {WWMethods,WWUtils} from "@/tools";
let interval;
let pophideTimeout, popAnimationTimeout;
import "./index.scss"

export default class WarningMessagePop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alarmno:0,
            showPop: false,
            showPopAnimation: false,
            loading: true,
            showAlarmTips:!!localStorage.getItem('warningType'),
            type: [],
            chosenType:[],
            selectAlarmId: [],
            isAllChecked:true
        };

        this.handleLoopGetWarningMessage = this.handleLoopGetWarningMessage.bind(this);
        this.handleWarningType = this.handleWarningType.bind(this);
        this.showWarningMassageModal = this.showWarningMassageModal.bind(this);
        this.hiddlePop = this.hiddlePop.bind(this);
        this.showPop = this.showPop.bind(this);
        this.getWarningType = this.getWarningType.bind(this);
    }

    componentDidMount() {
        this.audio = document.getElementById("bgMusic");
        this.handleLoopGetWarningMessage();
        this.getWarningType();
    }

    getWarningType() {
        let that = this;
        let url = WWMethods.getApiUrl("orgConfig");
        //报警推送配置
        url += `?entityId=${localStorage.getItem("organizationId")}&entityType=1&configType=202`;
        WWUtils.fetch(url,'GET',(data)=> {
            if(data && data.code === 0 && data.data) {
                let config_init = data.data.items;
                window.openVoice = Boolean(data.data.enableSound)
                //IOP是checked；mic是enable
                that.setState({
                    type: config_init
                },()=> localStorage.setItem("warningType", JSON.stringify(that.state.type)));
            }
        })
    }

    //每10秒执行查询最新消息
    handleLoopGetWarningMessage() {
        let that = this;
        clearInterval(interval);
        setTimeout(this.handleWarningType,10000); //10秒之后启动第一次报警
        interval = setInterval(function () {
            that.handleWarningType();
        }, 10000);
    }

    //获取最新报警信息个数，大于0才调用handleGetWarningMsg
    handleWarningType() {
        let that = this;
        let url = WWMethods.getApiUrl("alarmNo");
        WWUtils.fetch(WWUtils.getNoCacheURL(url),"GET",(data)=>{
            if (data) {
                let num = data.data;
                //大于0个报警，显示气泡
                if (num > 0 ) {
                    that.setState({
                        alarmno: num,
                        showPop: true,
                        showPopAnimation: true,
                    },()=>{
                        if(window.openVoice && that.audio) {
                            that.audio.play()
                        }
                        if($('.alarm_beel_container_activate')[0]){
                            $('#beelContainer').removeClass('alarm_beel_container_activate');
                            $('#beelContainer').addClass('alarm_beel_container_normal');
                            setTimeout(()=>{
                                $('#beelContainer').addClass('alarm_beel_container_activate')
                                $('#beelContainer').removeClass('alarm_beel_container_normal');
                            },0)
                        }
                        that.hiddlePop();
                    })
                }
            }
        })
    }


    /**
     * 弹出报警详情 新逻辑是先弹框 在拉数据
     * @returns {*}
     */
    showWarningMassageModal(){
        const {alarmno} = this.state;
        this.refs.WarningMassageContentModal.showModalMessage();
        this.setState({
            alarmno:0,
            loading: true
        });
        this.hiddlePop(0);
    }

    /**
     * 当鼠标指向气泡，气泡不消失，等移开后的5秒在消失
     */
    showPop() {
        pophideTimeout && clearTimeout(pophideTimeout);
        popAnimationTimeout && clearTimeout(popAnimationTimeout);
    }

    /**
     * 5秒后隐藏气泡
     */
    hiddlePop(timer=5000) {
        pophideTimeout = setTimeout(()=> {
            this.setState({
                showPopAnimation: false,
            });
        },timer)
        popAnimationTimeout = setTimeout(()=> {
            this.setState({
                showPop: false,
            });
        },timer+500)
    }



    render() {
        const { alarmno, showPop, showPopAnimation, loading,showAlarmTips } = this.state;
        let pop_class = showPopAnimation? 'alarm_pop_container alarm_pop_container_show':  'alarm_pop_container alarm_pop_container_hidden';
        return (
            showAlarmTips ?<div>
                    <div id='beelContainer' onClick={this.showWarningMassageModal} className={'alarm_beel_container_activate'}>
                        <div className={'default alarm_beel icon-baojing iconfont'}></div>
                    </div>
                    {
                        showPop?
                        <div onMouseOver={this.showPop}
                            onMouseOut={()=>this.hiddlePop()}
                            onClick={this.showWarningMassageModal} className={pop_class}>
                            {Strings.rs10786}
                            <span style={{fontSize: 15, fontWeight: 'bold', margin: '0 5px'}}>{alarmno}</span>
                            {Strings.rs10787}，{Strings.rs10902}
                        </div>:null}
                    <WarningMassageContentModal ref="WarningMassageContentModal" loading={loading}/>
                    <audio id="bgMusic">
                        <source src={"../../assets/mp3/alarm_new.mp3"} type="audio/mp3"/>
                    </audio>
                </div>:null)
    }
}
